import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
} from "chart.js"
import "chartjs-adapter-date-fns"
import "chart.js/auto"
import ChartDataLabels from "chartjs-plugin-datalabels"
import AnnotationPlugin from "chartjs-plugin-annotation"
import type { Theme } from "../theme/theme.types"

export const setupChart = (theme: Theme) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels,
    AnnotationPlugin
  )
  ChartJS.defaults.font.size = theme.defaultBodySize
  ChartJS.defaults.font.family = theme.fonts.body.fontFamily
  // @ts-ignore
  ChartJS.defaults.font.weight = theme.fonts.body.fontWeight // ChartJS types fontWeight as string only and says all mdn values are acceptable. They should have typed as string or number
  ChartJS.defaults.plugins.legend.display = false
  ChartJS.defaults.plugins.tooltip.enabled = true
  ChartJS.defaults.plugins.tooltip.displayColors = false
  ChartJS.defaults.plugins.tooltip.backgroundColor = theme.palette.coal.dark
}
